import { faBullseye } from "@fortawesome/pro-regular-svg-icons"
import { faTrash } from "@fortawesome/pro-solid-svg-icons"
import { IAdvertiserDomain } from "advertiser/model"
import { deleteAdvertiserDomain, editAdvertiserDomain } from "advertiser/tools/advertiser-domain"
import { translate } from "app/language/service"
import { messageSVC } from "message/service"
import React from "react"
import { FlexBox } from "ui/components/FlexBox"
import { ListActionButton } from "ui/components/main-layout/ListActionButton"

interface IAdvertiserDomainListActionsProps {
  allAdvertiserDomains: IAdvertiserDomain[]
  advertiserDomain: IAdvertiserDomain
  onEdit: (advertiserDomain: IAdvertiserDomain) => any
  onDelete: (advertiserDomainId: number) => any
}

export const AdvertiserDomainListActions = React.memo(
  ({ allAdvertiserDomains, advertiserDomain, onEdit, onDelete }: IAdvertiserDomainListActionsProps): JSX.Element => {
    const [isDeleting, setIsDeleting] = React.useState(false)
    return (
      <FlexBox
        sx={{
          gap: ".5rem",
          fontSize: "1.5rem"
        }}>
        <ListActionButton
          id={`advertiser-domains-${advertiserDomain.id}-edit-button`}
          icon={faBullseye}
          disabled={isDeleting}
          tooltip={translate("advertiser-domain.edit.title")}
          onClick={() => editAdvertiserDomain(allAdvertiserDomains, advertiserDomain, onEdit)}
        />
        <ListActionButton
          id={`advertiser-domains-${advertiserDomain.id}-delete-button`}
          tooltip={translate("advertiser-domain.delete.title")}
          disabled={isDeleting}
          isLoading={isDeleting}
          icon={faTrash}
          onClick={async () => {
            setIsDeleting(true)
            messageSVC.confirmMessage({
              icon: faTrash,
              addGenericConfirmMessage: true,
              confirmButtonLabel: translate("button.delete"),
              title: translate("advertiser.delete"),
              message: translate("advertiser-domain.delete.message", advertiserDomain.domain),
              onSuccess: async () => {
                try {
                  await deleteAdvertiserDomain(advertiserDomain.advertiser_id, advertiserDomain.id)
                  setIsDeleting(false)
                  onDelete(advertiserDomain.id)
                } catch (error) {
                  console.error("Error")
                  messageSVC.error(translate("advertiser-domain.delete.error"))
                  setIsDeleting(false)
                }
              },
              onCancel: () => setIsDeleting(false)
            })
          }}
        />
      </FlexBox>
    )
  }
)
